import { render, staticRenderFns } from "./korToMas.vue?vue&type=template&id=6e5c065a&scoped=true&"
import script from "./korToMas.vue?vue&type=script&lang=js&"
export * from "./korToMas.vue?vue&type=script&lang=js&"
import style0 from "./korToMas.vue?vue&type=style&index=0&id=6e5c065a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e5c065a",
  null
  
)

export default component.exports